module.exports = __webpack_public_path__ + "static/easy-image-2-37042f1f57a1df262f81fc2e893537c2.jpg";